<script setup>
const imgNumber = ref(1)
const imgSrc = computed (() => {
  return `https://gvs.weathernews.jp/common/images/banner/past_chart_pro_${imgNumber.value}.webp`
})
onMounted(() => {
  imgNumber.value = Math.floor(Math.random() * 2) + 1
})
</script>
<template>
  <div class="banner-content">
    <div class="sectiontitle">
      <h2 class="title">
        ウェザーニューズ関連サービス
      </h2>
    </div>
    <div class="banner">
      <h3 class="title">
        個人向けサービス
      </h3>
      <NuxtLink
        :to="`https://weathernews.jp/pro/?ref=onebox_pastchart&banner=${imgNumber}`"
        target="_blank"
        rel="noopener"
      >
        <img
          :src="imgSrc"
          alt="個人向けサービス"
        >
      </NuxtLink>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.banner-content {
  display: flex;
  flex-direction: column;
  gap: 10px;
  .sectiontitle {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .title {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: baseline;
      flex: 1;
      gap: 5px;
      color: #101010;
      font-size: 18px;
      font-weight: bold;
      line-height: 18px;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
  .banner {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    gap: 5px;
    max-width: 350px;
    img {
      width: 100%;
      aspect-ratio: 710 / 200;
      border-radius: 8px;
      overflow: hidden;
    }
    .title {
      display: flex;
      align-items: center;
      flex: 1;
      color: #101010;
      font-size: 13px;
      line-height: 13px;
      &::-webkit-scrollbar {
        display: none;
      }
      &::after {
        content: "";
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-left: 3px;
        background-image: url('https://gvs.weathernews.jp/onebox/img/header/icon_external.svg');
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        flex-shrink: 0;
      }
    }
  }
}
</style>
